import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { GlobalModel } from "../common/utils";

const initialState: GlobalModel = {
  loading: false,
  isFormUpdated: false,
};

const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    setLoading: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setIsFormUpdated: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.isFormUpdated = action.payload;
    },
  },
});

export const { setLoading, setIsFormUpdated } = globalSlice.actions;

export default globalSlice.reducer;
